import get from 'lodash/get';
import set from 'lodash/set';
import AES from 'crypto-js/aes';
import UTF8 from 'crypto-js/enc-utf8';

export default class DataStore {

    constructor(options) {
        for(const i in options) {
            this[i] = options[i];
        }
    }

    get(key, defaultValue) {
        return get(this.data, key, defaultValue);
    }

    set(key, value) {
        const data = this.data || {};

        set(data, key, value);

        this.data = data;
    }

    forget(key) {
        this.set(key, undefined);
    }

    clear() {
        this.data = {};
    }

    encrypt(string) {
        return this.encryptionKey ? AES.encrypt(string, this.encryptionKey).toString() : string;
    }

    decrypt(string) {
        return this.encryptionKey ? AES.decrypt(string, this.encryptionKey).toString(UTF8) : string;
    }

    get raw() {
        return window.localStorage.getItem(this.key);
    }

    get data() {
        try {
            return JSON.parse(this.decrypt(this.raw));
        }
        catch (e) {
            return {};
        }
    }

    set data(value) {
        let contents;

        try {
            contents = this.encrypt(JSON.stringify(value));
        }
        catch (e) {
            contents = {};
        }

        window.localStorage.setItem(this.key, contents);
    }

    set key(string) {
        this.$key = string;
    }

    get key() {
        return this.$key || 'config';
    }

    set name(string) {
        this.$name = string;
    }

    get name() {
        return this.$name || 'userData';
    }

    set encryptionKey(string) {
        this.$encryptionKey = string;
    }

    get encryptionKey() {
        return this.$encryptionKey;
    }

}
